import script from "./Note.vue?vue&type=script&setup=true&lang=js"
export * from "./Note.vue?vue&type=script&setup=true&lang=js"

import "./Note.vue?vue&type=style&index=0&id=5d7bb1ea&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7bb1ea"]])

export default __exports__